var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF8C42",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 24.3334C22.5421 24.3334 24.333 22.5425 24.333 20.3334C24.333 18.1242 22.5421 16.3334 20.333 16.3334C18.1239 16.3334 16.333 18.1242 16.333 20.3334C16.333 22.5425 18.1239 24.3334 20.333 24.3334Z",
    stroke: "#FF8C42",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8242 20.3834H18.8408",
    stroke: "#FF8C42",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.332 18.925V21.9167",
    stroke: "#FF8C42",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3337 13.2416C24.3337 14.8833 23.9087 16.3332 23.242 17.5916C22.5087 16.8166 21.4753 16.3333 20.3337 16.3333C18.1253 16.3333 16.3337 18.1249 16.3337 20.3333C16.3337 21.3583 16.7253 22.2916 17.3587 23C17.0503 23.1416 16.767 23.2583 16.517 23.3416C16.2337 23.4416 15.767 23.4416 15.4837 23.3416C13.067 22.5166 7.66699 19.0749 7.66699 13.2416C7.66699 10.6666 9.74199 8.58325 12.3003 8.58325C13.8087 8.58325 15.1587 9.31662 16.0003 10.4416C16.842 9.31662 18.192 8.58325 19.7003 8.58325C22.2587 8.58325 24.3337 10.6666 24.3337 13.2416Z",
    stroke: "#FF8C42",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0642811568205308a4e366c50b779ff5.svg";
export { ForwardRef as ReactComponent };